import { ModalProps } from '@chakra-ui/react';
import React from 'react';

import { ResponsiveModal } from '../../../../components/Layout/ResponsiveModal';
import { useMediaFlow } from '../../../../provider/MediaFlowProvider';

/**
 * !Must be enclosed by:
 * - **{@link MediaFlowProvider}**
 *
 * Responsive Modal which is controlled by a `MediaFlowProvider`
 * @see ResponsiveModal
 * @see MediaFlowProvider
 * @see useMediaFlow
 */
export const MediaFlowModal: React.FC<
  Partial<ModalProps> & {
    children?: React.ReactNode;
  }
> = (props) => {
  const { isOpen, onClose } = useMediaFlow();
  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      children={props.children}
      {...props}
    />
  );
};
